import { ServiceContentById } from '@/api';
import { CartItemDetails } from '@/base-api/types';
import { SharedDialog } from '@/components/dialog';
import { DialogProvider } from '@/contexts/dialog-context';

import { CartWidgetWrapper } from './cart-widget-wrapper';

interface CartRootWidgetInput {
  cartId: string;
  serviceContentById: ServiceContentById;
  cartItemDetails: CartItemDetails;
}

export function CartRootWidget({
  cartId,
  serviceContentById,
  cartItemDetails,
}: CartRootWidgetInput) {
  if (!serviceContentById) return;
  return (
    <DialogProvider>
      <CartWidgetWrapper
        cartId={cartId}
        serviceContentById={serviceContentById}
        cartItemDetails={cartItemDetails}
      />
      <SharedDialog />
    </DialogProvider>
  );
}
